import User from './User.Store';
import Info from './Info.Store';
import Client from './Client.Store';
import Message from './Message.Store';
import Firebase from './Firebase.Store';
import System from './System.Store';
import Esign from './Esign.Store';

const Store = {
  User,
  Info,
  Client,
  Message,
  Firebase,
  System,
  Esign,
};

// @ts-ignore
window.Store = Store;

export default Store;
